import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'arrow-narrow-left',
  'IconArrowNarrowLeft',
  [
    ['path', { d: 'M5 12l14 0', key: 'svg-0' }],
    ['path', { d: 'M5 12l4 4', key: 'svg-1' }],
    ['path', { d: 'M5 12l4 -4', key: 'svg-2' }],
  ],
);
